import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

let defaultState = {
    status: ''
}

@Injectable({
    providedIn: 'root'
})
export class GenerateDocumentsService {
    private store = new BehaviorSubject<any>(defaultState);
    public state$ = this.store.asObservable();

    status$ = this.state$.pipe(
        map(state => state.status),
        distinctUntilChanged()
    );

    getStatus(): string {
        return this.store.value.status;
    }

    setStatus(status: string) {
        this.updateState({ ...defaultState, status });
    }

    updateState(state: any): void {
        this.store.next(defaultState = state);
    }
}